export default __webpack_public_path__ + "static/media/element_64.d605c9c6.webp";